import { useState, useEffect } from 'react';

const DarkModeToggle = () => {
  // State to track dark mode
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Load initial value from localStorage
    return localStorage.getItem('darkMode') === 'true';
  });

  // Effect to update the `html` class and save preference
  useEffect(() => {
    const htmlElement = document.documentElement;
    if (isDarkMode) {
      htmlElement.classList.add('dark-mode');
    } else {
      htmlElement.classList.remove('dark-mode');
    }
    // Save preference to localStorage
    localStorage.setItem('darkMode', isDarkMode.toString());
  }, [isDarkMode]);

  // Toggle dark mode
  const handleToggle = () => {
    setIsDarkMode((prevMode) => !prevMode);
  };

  return (
    <button
      onClick={handleToggle}
      style={{
        padding: '10px',
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '50%',
        cursor: 'pointer',
      }}
      aria-label={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
    >
      <i
        className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'}`}
        style={{
          color: isDarkMode ? '#FFFFF' : '#333', // Bright yellow for light mode, dark gray for dark mode
          fontSize: '1.5rem',
        }}
      />
    </button>
  );
};

export default DarkModeToggle;